import { ActionTypes } from 'redux/utils/Value'

export default ActionTypes('TRANSPORTATION_RIDE_REQUEST')